module.exports = __webpack_public_path__ + "static/media/crosshair-light.b3e42221.svg";